import { Directive, forwardRef, Inject, TemplateRef } from '@angular/core';

import { StepWizardStepDirective } from './step-wizard-step.directive';

@Directive({ standalone: false, selector: '[adsptStepWizardStepSide]' })
export class StepWizardStepSideDirective {
  constructor(
    tr: TemplateRef<any>,
    @Inject(forwardRef(() => StepWizardStepDirective))
    readonly step: StepWizardStepDirective,
  ) {
    this.step.sideStep$.next(tr);
  }
}
